import urlConfig from 'Url';
export const INIT_STATE = 'INIT_STATE';
export const QUERY_REFUNDCHANGE_FEE = 'QUERY_REFUNDCHANGE_FEE';
export const SAVE_QUERYINFO = 'SAVE_QUERYINFO';
export const QUERY_REFUND_FEE = 'QUERY_REFUND_FEE';
export const QUERY_CHANGE_FEE = 'QUERY_CHANGE_FEE';
export const GET_AD_INFO = 'GET_AD_INFO';
export const SELECT_STYLE = 'SELECT_STYLE';

export function init() {
  return { type: INIT_STATE };
}

export function saveQueryInfo(data) {
  return { type: SAVE_QUERYINFO, data };
}

export function queryRefundChangeFee(data) {
  return {
    type: QUERY_REFUNDCHANGE_FEE,
    payload: {
      request: {
        url: urlConfig.queryRefundChangeFee,
        method: 'post',
        data,
      },
    },
  };
}
export function selectTabStyle(data) {
  return { type: SELECT_STYLE, data };
}

export function queryRefundFee(data) {
  return {
    type: QUERY_REFUND_FEE,
    payload: {
      request: {
        url: urlConfig.queryRefundFee,
        method: 'post',
        data,
      },
    },
  };
}

export function queryChangeFee(data) {
  return {
    type: QUERY_CHANGE_FEE,
    payload: {
      request: {
        url: urlConfig.queryChangeFee,
        method: 'post',
        data,
      },
    },
  };
}

export function getAdInfo(data) {
  return {
    type: GET_AD_INFO,
    payload: {
      request: {
        url: urlConfig.getAdInfo,
        method: 'post',
        data,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/changeRefundExplain/modules/actions.js